import { render, staticRenderFns } from "./PcBusinessCard.vue?vue&type=template&id=24392fea&scoped=true&"
import script from "./PcBusinessCard.vue?vue&type=script&lang=ts&"
export * from "./PcBusinessCard.vue?vue&type=script&lang=ts&"
import style0 from "./PcBusinessCard.vue?vue&type=style&index=0&id=24392fea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24392fea",
  null
  
)

export default component.exports